import { useCallback, useRef } from 'react';
import { useSubmitAdvancedDialog } from 'server';

export const useGetSubmitAdvancedDialog = () => {
    const inProgress = useRef(false);
    const submitAdvancedDialog = useSubmitAdvancedDialog();

    return useCallback(({ buttonId, failedHTCMDs, actionId, windowSessionId }) => {
        if (inProgress.current) {
            return;
        }

        inProgress.current = true;

        return submitAdvancedDialog({
            actionId,
            buttonId,
            windowSessionId,
            failedHTCMDs
        });
    }, [inProgress, submitAdvancedDialog]);
};
